import ready, { HTML } from 'Utils';
import {initMobileNav, initHeaderHeight, initNavAnchor} from 'Components/initMobileNav';
import initRolloverCards from 'Components/initRolloverCards';
import initCarousel from 'Components/initCarousel';

ready(() => {
  HTML.classList.add('is-loaded');
  initMobileNav();
  initHeaderHeight();
  initNavAnchor();
  initRolloverCards();
  initCarousel();
});
